import { render, staticRenderFns } from "./news-item.component.vue?vue&type=template&id=22e677b1&"
import script from "./news-item.component.vue?vue&type=script&lang=js&"
export * from "./news-item.component.vue?vue&type=script&lang=js&"
import style0 from "./news-item.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports